import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

const log = new LoggerService('MAILING SERVICE');

@Injectable({
  providedIn: 'root',
})
export class MailService extends ApiBaseService<any> {
  constructor() {
    super('send-mail');
  }

  public async sendMail(data: any) {
    const apiResponse = await this.request<any>('send-mail', 'POST', data);
    log.debug('[sendMail] apiResponse', apiResponse);
    return apiResponse;
  }
}
